import { render, staticRenderFns } from "./configurationActivities.vue?vue&type=template&id=754147d5&scoped=true&"
import script from "./configurationActivities.vue?vue&type=script&lang=js&"
export * from "./configurationActivities.vue?vue&type=script&lang=js&"
import style0 from "./configurationActivities.vue?vue&type=style&index=0&id=754147d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754147d5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('754147d5')) {
      api.createRecord('754147d5', component.options)
    } else {
      api.reload('754147d5', component.options)
    }
    module.hot.accept("./configurationActivities.vue?vue&type=template&id=754147d5&scoped=true&", function () {
      api.rerender('754147d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/activities/components/configurationActivities.vue"
export default component.exports